import React from 'react';
import {Button, Icon, Row, Col, InputNumber, Checkbox, message} from 'antd';
import {WeaSearchGroup, WeaFormItem, WeaSelect, WeaBrowser, WeaTable,WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;

export default class Tab4Share extends React.Component {
    state = {
        key: 0,
        sharetype: '7',
        sharevalue: '',
        includeSub: false,
        seclevelmin: 0,
        seclevelmax: 100,
        seclevel: '0-100',
        rolelevel: '0',
        jobtitlelevel: '1',
        jobtitlesharevalue: '',
        shareTypeName: '',
        shareValueName: '',
        jobtitlesharevaluename: '',
        objReplaceDatas: [],
        jobReplaceDatas: [],
        selectedRowKeys: [],
        eHasShareRight: this.props.eShare.eHasShareRight,
        eOldShareList: this.props.eShare.eOldShareList || [], // 老版共享数据
        eShareList: this.props.eShare.eShareList || [] // 新版共享数据
    };

    constructor(props) {
        super(props);
        this.getSaveValues = this.getSaveValues.bind(this);
    }

    render() {
        const {eHasShareRight} = this.state;

        if (eHasShareRight) {
            const {
                sharetype,
                sharevalue,
                shareValueName,
                includeSub,
                seclevelmin,
                seclevelmax,
                rolelevel,
                jobtitlelevel,
                jobtitlesharevalue,
                jobtitlesharevaluename,
                objReplaceDatas,
                jobReplaceDatas,
                selectedRowKeys
            } = this.state;
            let objItemVisible = true;
            let seclevelItemVisible = true;
            let rolelevelItemVisible = false;
            let jobtitlelevelItemVisible = false;

            let objItem = '';
            let rolelevelItem = '';
            let jobtitlelevelItem = '';

            if (sharetype === '3') { // 部门
                objItem = (
                    <WeaBrowser
                        type={57}
                        isSingle={false}
                        title={getLabel(27511, '部门')}
                        replaceDatas={
                            sharevalue != '' && shareValueName != '' ?
                                [{
                                    id: sharevalue,
                                    name: shareValueName
                                }] : []}
                        tabs={[
                            {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                            {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                        ]}

                        viewAttr={3}
                        onChange={(ids, names, datas) => this.setState({sharevalue: ids, shareValueName: names})}
                    />
                );
            } else if (sharetype === '2') { // 分部
                objItem = (
                    <WeaBrowser
                        type={194}
                        isSingle={false}
                        title={getLabel(33553, '分部')}
                        tabs={[
                            {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                            {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                        ]}
                        replaceDatas={
                            sharevalue != '' && shareValueName != '' ?
                                [{
                                    id: sharevalue,
                                    name: shareValueName
                                }] : []}
                        viewAttr={3}
                        onChange={(ids, names, datas) => this.setState({sharevalue: ids, shareValueName: names})}
                    />
                );
            } else if (sharetype === '7') { // 安全级别
                objItemVisible = false;
            } else if (sharetype === '1') { // 人力资源
                seclevelItemVisible = false;

                objItem = (
                    <WeaBrowser
                        type={17}
                        isSingle={false}
                        title={getLabel(179, '人力资源')}
                        viewAttr={3}
                        replaceDatas={
                            sharevalue != '' && shareValueName != '' ?
                                [{
                                    id: sharevalue,
                                    name: shareValueName
                                }] : []}
                        onChange={(ids, names, datas) => this.setState({sharevalue: ids, shareValueName: names})}
                    />
                );
            } else if (sharetype === '6') { // 角色
                rolelevelItemVisible = true;

                objItem = (
                    <WeaBrowser
                        type={267}
                        quickSearchName={'rolesmark'}
                        isSingle={true}
                        title={getLabel(122, '角色')}
                        viewAttr={3}
                        replaceDatas={
                            sharevalue != '' && shareValueName != '' ?
                                [{
                                    id: sharevalue,
                                    name: shareValueName
                                }] : []}
                        onChange={(ids, names, datas) => this.setState({sharevalue: ids, shareValueName: names})}
                    />
                );

                rolelevelItem = (
                    <WeaSelect
                        options={[
                            {key: '0', selected: false, showname: getLabel(27511, '部门')},
                            {key: '1', selected: false, showname: getLabel(33553, '分部')},
                            {key: '2', selected: false, showname: getLabel(140, '总部')}
                        ]}
                        value={rolelevel}
                        onChange={value => this.setState({rolelevel: value})}
                    />
                );
            } else if (sharetype === '8') { // 岗位
                seclevelItemVisible = false;
                jobtitlelevelItemVisible = true;

                objItem = (
                    <WeaBrowser
                        type={278}
                        isSingle={false}
                        title={getLabel(6086, '岗位')}
                        viewAttr={3}
                        replaceDatas={
                            sharevalue != '' && shareValueName != '' ?
                                [{
                                    id: sharevalue,
                                    name: shareValueName
                                }] : []}
                        onChange={(ids, names, datas) => this.setState({sharevalue: ids, shareValueName: names})}
                    />
                );

                let jobtitlelevelObj = '';
                if (jobtitlelevel == '2') {
                    jobtitlelevelObj = (
                        <WeaBrowser
                            type={57}
                            isSingle={false}
                            title={getLabel(27511, '部门')}
                            tabs={[
                                {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                                {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                            ]}
                            viewAttr={3}
                            replaceDatas={
                                jobtitlesharevalue != '' && jobtitlesharevaluename != '' ?
                                    [{
                                        id: jobtitlesharevalue,
                                        name: jobtitlesharevaluename
                                    }] : []}
                            onChange={(ids, names, datas) => this.setState({jobtitlesharevalue: ids, jobtitlesharevaluename: names})}
                        />
                    );
                } else if (jobtitlelevel == '3') {
                    jobtitlelevelObj = (
                        <WeaBrowser
                            type={194}
                            isSingle={false}
                            title={getLabel(33553, '分部')}
                            tabs={[
                                {key: '1', name: getLabel(384541, '按组织架构'), selected: false},
                                {key: '2', name: getLabel(130619, '按列表'), selected: false, dataParams: {list: 1}}
                            ]}
                            replaceDatas={
                                jobtitlesharevalue != '' && jobtitlesharevaluename != '' ?
                                    [{
                                        id: jobtitlesharevalue,
                                        name: jobtitlesharevaluename
                                    }] : []}
                            viewAttr={3}
                            onChange={(ids, names, datas) => this.setState({jobtitlesharevalue: ids, jobtitlesharevaluename: names})}
                        />
                    );
                }

                jobtitlelevelItem = (
                    <Row gutter={16}>
                        <Col span={8}>
                            <WeaSelect
                                options={[
                                    {key: '1', selected: false, showname: getLabel(140, '总部')},
                                    {key: '2', selected: false, showname: getLabel(19438, '指定部门')},
                                    {key: '3', selected: false, showname: getLabel(19437, '指定分部')}
                                ]}
                                value={jobtitlelevel}
                                style={{width: '100px'}}
                                onChange={value => this.setState({jobtitlelevel: value, jobReplaceDatas: [], jobtitlesharevalue: '', jobtitlesharevaluename: ''})}
                            />
                        </Col>
                        <Col span={16}>
                            {jobtitlelevelObj}
                        </Col>
                    </Row>
                );
            }

            // 记录选中的tab数据行
            const _self = this;
            const rowSelection = {
                onChange(selectedRowKeys) {
                    // if(selectedRowKeys==''){
                    //     $('#shareDel').css("background-color","");
                    // }else{
                    //     $('#shareDel').css("background-color","#55a1f8");
                    // }

                    _self.setState({selectedRowKeys: selectedRowKeys})
                }
            };

            // 表格数据源
            const dataSource = this.state.eOldShareList.concat(this.state.eShareList);

            // 表格列
            const columns = [{
                title: getLabel(21956, '对象类型'),
                dataIndex: 'shareTypeName'
            }, {
                title: getLabel(106, '对象'),
                dataIndex: 'shareValueName'
            }, {
                title: getLabel(683, '安全级别'),
                dataIndex: 'securityLevel'
            }];

            return (
                <div>
                    <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                        <WeaFormItem label={getLabel(21956, '对象类型')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                            <WeaSelect
                                options={[
                                    {key: '3', selected: false, showname: getLabel(27511, '部门')},
                                    {key: '2', selected: false, showname: getLabel(33553, '分部')},
                                    {key: '7', selected: false, showname: getLabel(1340, '所有人')},
                                    {key: '1', selected: false, showname: getLabel(179, '人力资源')},
                                    {key: '6', selected: false, showname: getLabel(122, '角色')},
                                    {key: '8', selected: false, showname: getLabel(6086, '岗位')}
                                ]}
                                value={sharetype}
                                style={{width: '100px'}}
                                onChange={value => this.setState({
                                    sharetype: value, objReplaceDatas: [], jobReplaceDatas: [], sharevalue: '', shareValueName: '', jobtitlesharevalue: '', jobtitlesharevaluename: ''
                                })}
                            />
                        </WeaFormItem>
                        {
                            objItemVisible ?
                                <WeaFormItem label={getLabel(106, '对象')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                                    {
                                        sharetype === '3' || sharetype === '2' ?
                                            <Row gutter={16}>
                                                <Col span={16}>
                                                    {objItem}
                                                </Col>
                                                <Col span={8}>
                                                    <Checkbox checked={includeSub} onChange={e => this.setState({includeSub: e.target.checked})}>{getLabel(125963, '含下级')}</Checkbox>
                                                </Col>
                                            </Row> : objItem
                                    }
                                </WeaFormItem> : ''
                        }
                        {
                            rolelevelItemVisible ?
                                <WeaFormItem label={getLabel(21958, '角色级别')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                                    {rolelevelItem}
                                </WeaFormItem> : ''
                        }
                        {
                            jobtitlelevelItemVisible ?
                                <WeaFormItem label={getLabel(28169, '岗位级别')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                                    {jobtitlelevelItem}
                                </WeaFormItem> : ''
                        }
                        {
                            seclevelItemVisible ?
                                <WeaFormItem label={getLabel(683, '安全级别')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                                    <InputNumber defaultValue={seclevelmin} onChange={value => this.setState({seclevelmin: value})}/>
                                    <span style={{margin: '0 5px'}}>-</span>
                                    <InputNumber defaultValue={seclevelmax} onChange={value => this.setState({seclevelmax: value})}/>
                                </WeaFormItem> : ''
                        }
                    </WeaSearchGroup>
                    <WeaSearchGroup title={getLabel(1279, '共享信息')} needTigger={true} showGroup={true} customComponent={
                        <div>
                            <Button type="primary" className="portal-esetting-wsg-btn"   onClick={this.onAdd.bind(this)}>
                                <Icon type="plus" style={{color: '#fff'}}/>
                            </Button>
                            <Button type="primary" disabled={!(selectedRowKeys && selectedRowKeys.length)}   id="shareDel" className="portal-esetting-wsg-btn"  onClick={this.onDelete.bind(this)}>
                                <Icon type="minus" style={{color: '#fff'}}/>
                            </Button>
                        </div>
                    }>
                        <WeaTable rowSelection={rowSelection} columns={columns} dataSource={dataSource} pagination={false}/>
                    </WeaSearchGroup>
                </div>
            );
        } else {
            return (
                <div style={{width: '100%', height: '50px', lineHeight: '50px', borderBottom: '1px solid #e9e9e9', textAlign: 'center'}}>
                    <Icon type="exclamation-circle" style={{marginRight: '8px', color: '#fa0'}}/>
                    <span>{getLabel(2012, '对不起，您暂时没有权限！')}</span>
                </div>
            );
        }
    }

    onAdd() {
        const {
            sharetype,
            sharevalue,
            includeSub,
            seclevelmin,
            seclevelmax,
            seclevel,
            rolelevel,
            jobtitlelevel,
            jobtitlesharevalue
        } = this.state;
        let {key, shareTypeName, shareValueName, jobtitlesharevaluename, eShareList} = this.state;

        if (sharetype != '7' && (!sharevalue.trim() || (jobtitlelevel != '1' && !jobtitlesharevalue.trim()))) {
            message.warning(getLabel(15859, '必要信息不完整！'));
        } else {
            // 部门(3)、分部(2)、所有人(7)、人力资源(1)、角色(6)、岗位(8)
            shareTypeName = {
                3: getLabel(27511, '部门'),
                2: getLabel(33553, '分部'),
                7: getLabel(1340, '所有人'),
                1: getLabel(179, '人力资源'),
                6: getLabel(122, '角色'),
                8: getLabel(6086, '岗位')
            }[sharetype];

            if ((sharetype == '3' || sharetype == '2') && includeSub) {
                shareValueName += '('+getLabel(125963, '含下级')+')';
            } else if (sharetype == '7') {
                shareValueName = getLabel(1340, '所有人');
            } else if (sharetype == '6') {
                if (rolelevel == 2) {
                    shareValueName += '/' + getLabel(140, '总部');
                } else if (rolelevel == 1) {
                    shareValueName += '/' + getLabel(33553, '分部');
                } else if (rolelevel == 0) {
                    shareValueName += '/' + getLabel(27511, '部门');
                }
            } else if (sharetype == '8') {
                if (jobtitlelevel == 1) {
                    shareValueName += '/' + getLabel(140, '总部');
                } else if (jobtitlelevel == 2) {
                    shareValueName += '/'+getLabel(19438	, '指定部门')+'/' + jobtitlesharevaluename;
                } else if (jobtitlelevel == 3) {
                    shareValueName += '/'+getLabel(19437	, '指定分部')+'/' + jobtitlesharevaluename;
                }
            }

            eShareList.push({
                key: --key,
                shareType: sharetype,
                shareValue: sharevalue,
                includeSub: includeSub,
                roleLevel: rolelevel,
                securityMinLevel: seclevelmin,
                securityMaxLevel: seclevelmax,
                securityLevel: sharetype == '1' || sharetype == '8' ? '' : seclevelmin + '-' + seclevelmax,
                jobShareLevel: jobtitlelevel,
                jobShareValue: jobtitlesharevalue,
                shareTypeName: shareTypeName,
                shareValueName: shareValueName
            });
            this.setState({key: key, eShareList: eShareList});
        }
    }

    onDelete() {
        const {selectedRowKeys, eOldShareList, eShareList} = this.state;

        let isOld = false;
        if (selectedRowKeys && selectedRowKeys.length) {
            const __selectedRowKeys = selectedRowKeys.slice();
            for (let i = 0, len = __selectedRowKeys.length; i < len; i++) {
                selectedRowKeys.splice(i, 1);

                for (let j = 0, len2 = eOldShareList.length; j < len2; j++) {
                    if (eOldShareList[j].key == __selectedRowKeys[i]) {
                        eOldShareList.splice(j, 1);
                        isOld = true;
                        break;
                    }
                }

                if (!isOld) {
                    for (let k = 0, len3 = eShareList.length; k < len3; k++) {
                        if (eShareList[k].key == __selectedRowKeys[i]) {
                            eShareList.splice(k, 1);
                            break;
                        }
                    }
                }
            }
        }

        this.setState({eOldShareList: eOldShareList, eShareList: eShareList});
    }


    getSaveValues() {
        return {
            eOldShareList: this.state.eOldShareList,
            eShareList: this.state.eShareList
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/Tab4Share.js